import { createHTTPClient } from '@/utils/request';
import { env } from '@/utils/env';
import { getStorage } from '@/utils/localStorage';

import AccountsService from './accounts';
import LocationsService from './locations';
import ConfigService from './config';
import ExamService from './examsrest';
import CatalogsRestService from './catalogsrest';
import TopicsRestService from './topicsrest';
import QuestionsRestService from './questionsrest';
import AlternativesRestService from './alternativesrest';
import StudentExamsRest from './studentExamsRest';
import SellableStudentExamsRest from './sellableStudentExamsRest';

const ExternalHTTPClient = createHTTPClient({
  baseURL: 'https://questions-production-config.s3-sa-east-1.amazonaws.com/',
});

const QuestionsMSHTTPClient = createHTTPClient({
  baseURL: env.VUE_APP_QUESTIONS_ENDPOINT,
  headers: {
    'Content-Type': 'application/json',
    'X-Vertical': sessionStorage.getItem('vertical') || 'concursos',
    Authorization: `Bearer ${getStorage('token')}`,
  },
});

const QuestionsMSHTTPClientMultiForm = createHTTPClient({
  baseURL: env.VUE_APP_QUESTIONS_ENDPOINT,
  headers: {
    'X-Vertical': sessionStorage.getItem('vertical') || 'concursos',
    Authorization: `Bearer ${getStorage('token')}`,
  },
});

const CatalogMSHTTPClient = createHTTPClient({
  baseURL: env.VUE_APP_CATALOGS_ENDPOINT,
  headers: {
    'Content-Type': 'application/json',
    'X-Vertical': sessionStorage.getItem('vertical') || 'concursos',
    Authorization: `Bearer ${getStorage('token')}`,
  },
});

const AccountHTTPClient = createHTTPClient({
  baseURL: env.VUE_APP_ACCOUNTS_URL,
  headers: {
    'X-Version': 'v2',
    Authorization: `Bearer ${getStorage('token')}`,
  },
});

export default {
  accounts: AccountsService(AccountHTTPClient),
  locations: LocationsService(ExternalHTTPClient),
  config: ConfigService(QuestionsMSHTTPClient),
  examsrest: ExamService(QuestionsMSHTTPClient),
  catalogsrest: CatalogsRestService(CatalogMSHTTPClient),
  topicsrest: TopicsRestService(QuestionsMSHTTPClient),
  questionsrest: QuestionsRestService(QuestionsMSHTTPClient),
  alternativesrest: AlternativesRestService(QuestionsMSHTTPClient),
  studentExamsRest: StudentExamsRest(QuestionsMSHTTPClient, QuestionsMSHTTPClientMultiForm),
  sellableStudentExamsRest: SellableStudentExamsRest(QuestionsMSHTTPClient),
};
